import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: 1,
    title: 'Limpia y Seca',
    desc: 'Asegúrate de que la piel de tu abdomen esté limpia y seca antes de aplicar.',
    img: 'https://cdn.magicpatterns.com/uploads/uQvT1kHqMRqg8QiFhRmEyz/ChatGPT_Image_Jan_22,_2026,_11_03_08_PM.png'
  }, {
    num: 2,
    title: 'Aplica el Parche',
    desc: 'Coloca StingFit sobre el ombligo o en la zona baja del abdomen antes de dormir.',
    img: 'https://cdn.magicpatterns.com/uploads/eSqPCKkytnik6c7fMVQCWm/ChatGPT_Image_Jan_22,_2026,_10_49_35_PM.png'
  }, {
    num: 3,
    title: 'Resultados Visibles',
    desc: 'Duerme tranquilamente mientras los ingredientes activos trabajan durante 8 horas.',
    img: 'https://cdn.magicpatterns.com/uploads/1SjGZqNB54e9vp3Apd26ai/ChatGPT_Image_Jan_22,_2026,_11_03_11_PM.png'
  }];
  return <Section data-id="element-135">
      <div className="text-center mb-12" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-137">
          Tan simple que se convertirá en hábito
        </h2>
        <p className="text-gray-600" data-id="element-138">
          Solo 30 segundos cada noche para transformar tu cuerpo.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-139">
        {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center group" data-id="element-140">
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden mb-6 shadow-lg bg-gradient-to-br from-[#F4E4C1] to-white" data-id="element-141">
              <img src={step.img} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-142" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-143"></div>
              <div className="absolute top-4 left-4 w-12 h-12 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg z-10" data-id="element-144">
                {step.num}
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-145">
              {step.title}
            </h3>
            <p className="text-gray-600" data-id="element-146">{step.desc}</p>
          </div>)}
      </div>

      {/* Additional visual guide */}
      <div className="mt-12 bg-[#F4E4C1]/30 rounded-2xl p-8 border border-[#D4AF37]/20" data-id="element-147">
        <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-148">
          <div className="flex items-center gap-2" data-id="element-149">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-150">
              1
            </div>
            <span className="text-sm text-gray-700" data-id="element-151">Piel limpia</span>
          </div>
          <div className="text-gray-400" data-id="element-152">→</div>
          <div className="flex items-center gap-2" data-id="element-153">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-154">
              2
            </div>
            <span className="text-sm text-gray-700" data-id="element-155">Aplicar parche</span>
          </div>
          <div className="text-gray-400" data-id="element-156">→</div>
          <div className="flex items-center gap-2" data-id="element-157">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-158">
              3
            </div>
            <span className="text-sm text-gray-700" data-id="element-159">8 horas de acción</span>
          </div>
          <div className="text-gray-400" data-id="element-160">→</div>
          <div className="flex items-center gap-2" data-id="element-161">
            <span className="text-2xl" data-id="element-162">✨</span>
            <span className="text-sm font-bold text-[#2D5016]" data-id="element-163">Resultados</span>
          </div>
        </div>
      </div>
    </Section>;
}